import { render, staticRenderFns } from "./XSwitcherCustom.vue?vue&type=template&id=9c0e81d0&scoped=true&"
import script from "./XSwitcherCustom.vue?vue&type=script&lang=ts&"
export * from "./XSwitcherCustom.vue?vue&type=script&lang=ts&"
import style0 from "./XSwitcherCustom.vue?vue&type=style&index=0&id=9c0e81d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0e81d0",
  null
  
)

export default component.exports